module.exports = require("/Volumes/DATA/projects/ah-pluskarla/.gatsby/gatsby-browser.ts");